<template>
  <Slideover
title="Change Area" :open="open" :actions="[
    {
      text: 'Save',
      theme: 'primary',
      disabled: isSubmitting || !store.isOnline || !form.AREA,
      method: handleSubmit
    }
  ]" @close="close">
    <form class="space-y-6" @submit.prevent="handleSubmit">
      <!-- Basic Information -->
      <div class="flex flex-col gap-6 ">


        <p class="text-sm text-gray-500">
          Current Area: {{ store.enteredArea }}
        </p>

        <label class="block text-sm font-medium text-gray-700">New Area</label>
        <input
v-model="form.AREA" type="text" required
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          placeholder="Enter new Area" />



      </div>


    </form>
  </Slideover>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Slideover from '@/components/partials/Slideover.vue'
import useStockTake from '@/stores/stocktakestore'
import useToasterStore from '@/stores/toaster'

interface Props {
  open: boolean
}

const props = defineProps<Props>()
const emit = defineEmits(['close'])

const store = useStockTake()
const toaster = useToasterStore()
const isSubmitting = ref(false)

// Form data
const form = ref({
  AREA: '',
})


// Stop polling when form opens, restart when closes
watch(() => props.open, (newOpen) => {
  store.setFormOpen(newOpen)
  if (newOpen) {
    store.stopPolling()
    resetForm()
  } else {
    store.startPolling()
  }
})

function resetForm() {
  form.value = {
    AREA: '',
  }
}

async function handleSubmit() {
  if (isSubmitting.value || !store.isOnline) return

  isSubmitting.value = true

  store.changeArea(form.value.AREA)

  // Show success popup

  toaster.success({
    text: `Area Changed succussfully to: ${store.enteredArea}`,
  })

  isSubmitting.value = false


  // Close the form
  close()

}

function close() {
  emit('close')
}
</script>
